import {
  Typography,
  Divider,
  TextField,
  InputLabel,
  MenuItem,
  Select,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { VALIDATION, LABEL } from '../../../theme/constants';
import moment from 'moment-timezone';
import Autocomplete from '@mui/material/Autocomplete';
import EditableList from '../../molecules/EditableList';
import { ThemeProvider } from '@mui/material/styles';
import { CRPTheme } from '../../../theme/theme';

function UpdateContainerRelease(props) {
  const {
    classes,
    container,
    terminals,
    handleInpContainerTypeChange,
    setAutoCompleteValue,
    handleInpReleaseValidFromChange,
    handleInpReleaseValidUntilChange,
    handleInpEmptyReturnReference,
    handleInpReleaseOrderReference,
    handleInpEquipmentSupplier,
    handleInpEquipmentStatus,
    handleInpFullEmptyIndicator,
    handleInpEquipmentOperator,
    handleInpVesselCallSign,
    handleInpVesselName,
    handleInpImoNumber,
    handleInpStayNumber,
    handleInpVoyageNumber,
    handleInpIsCarrierHaulage,
    handleSubmit,
    terminalCodeError,
    releaseDateTimeUtcError,
    expirationDateTimeUtcError,
  } = props;

  const convertDateTime = (dateTime) => {
    return moment(dateTime).local().format('YYYY-MM-DD');
  };

  const checkDatesAndHandleSubmit = (event) => {
    if (container.releaseDateTimeUtc === '') {
      container.releaseDateTimeUtc = null;
    }

    if (container.expirationDateTimeUtc === '') {
      container.expirationDateTimeUtc = null;
    }
    handleSubmit(event);
  };

  const isCarrierHaulage = container.releaseRightContextData.isCarrierHaulage;

  return (
    <ThemeProvider theme={CRPTheme}>
      <Typography variant={'h5'}>{LABEL.COMMERCIAL_RELEASE_UPDATE_TITLE}</Typography>
      <Divider />
      <Grid container spacing={3} className={classes.gridMargin}>
        <Grid size={6}>
          <TextField
            id="inpContainerNumber"
            type="text"
            label={LABEL.CONTAINER_NUMBER}
            value={container.equipmentNumber}
            inputProps={{
              readOnly: true,
            }}
            fullWidth
            disabled
          />
        </Grid>
        <Grid size={6}>
          <TextField
            id="inpReleaseIdentification"
            type="text"
            value={container.releaseIdentification}
            label={LABEL.RELEASE_IDENTIFICATION}
            inputProps={{
              readOnly: true,
            }}
            fullWidth
            disabled
          />
        </Grid>
        <Grid size={12}>
          <EditableList
            headers={[LABEL.BL_NUMBERS]}
            newItem={{ blNumber: undefined }}
            addLabel={LABEL.ADD_BL_NUMBER}
            settings={{
              blNumber: {
                type: 'text',
              },
            }}
            items={container.billOfLadingNumbers.map((blNumber) => ({ blNumber }))}
          />
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <Grid container spacing={3} className={classes.gridMargin}>
        <Grid size={4}>
          <TextField
            id="inpValidFromDate"
            error={releaseDateTimeUtcError}
            label={LABEL.RELEASE_VALID_FROM}
            helperText={releaseDateTimeUtcError ? VALIDATION.REL_DATE_MUST_BE_BEFORE_EXP_DATE : ''}
            type="date"
            defaultValue={convertDateTime(container.releaseDateTimeUtc)}
            onChange={(e) => handleInpReleaseValidFromChange(e)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid size={4}>
          <TextField
            id="inpValidUntilDate"
            label={LABEL.RELEASE_VALID_UNTIL}
            error={expirationDateTimeUtcError}
            helperText={expirationDateTimeUtcError ? VALIDATION.EXP_DATE_MUST_BE_GREATER_THAN : ''}
            type="date"
            defaultValue={convertDateTime(container.expirationDateTimeUtc)}
            onChange={(e) => handleInpReleaseValidUntilChange(e)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid size={4}>
          <Autocomplete
            id="inpTerminalCode"
            options={terminals}
            getOptionLabel={(terminal) =>
              `${terminal.name} (${terminal.portLoCode} ${terminal.code})`
            }
            value={terminals.find((t) => t.code === container.terminalCode)}
            onChange={(e, value) => setAutoCompleteValue(e, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={LABEL.CHOOSE_TERMINAL}
                fullWidth
                error={terminalCodeError}
                helperText={terminalCodeError ? VALIDATION.TERMINAL_REQUIRED : ''}
              />
            )}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpContainerType"
            type="text"
            value={container.equipmentType}
            onChange={(e) => handleInpContainerTypeChange(e)}
            label={LABEL.CONTAINER_TYPE}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpEmptyReturnReference"
            label={LABEL.EMPTY_RETURN_REFERENCE}
            type="text"
            value={container.emptyReturnReference}
            onChange={(e) => handleInpEmptyReturnReference(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpReleaseOrderReference"
            label={LABEL.RELEASE_ORDER_REFERENCE}
            type="text"
            value={container.releaseOrderReference}
            onChange={(e) => handleInpReleaseOrderReference(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpEquipmentStatus"
            type="text"
            value={container.releaseRightContextData.equipmentStatus}
            onChange={(e) => handleInpEquipmentStatus(e)}
            label={LABEL.EQUIPMENT_STATUS}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpEquipmentSupplier"
            label={LABEL.EQUIPMENT_SUPPLIER}
            type="text"
            value={container.releaseRightContextData.equipmentSupplier}
            onChange={(e) => handleInpEquipmentSupplier(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpEquipmentOperator"
            label={LABEL.EQUIPMENT_OPERATOR}
            type="text"
            value={container.releaseRightContextData.equipmentOperator}
            onChange={(e) => handleInpEquipmentOperator(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpVesselCallSign"
            type="text"
            value={container.releaseRightContextData.vesselCallSign}
            onChange={(e) => handleInpVesselCallSign(e)}
            label={LABEL.VESSEL_CALLSIGN}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpVesselName"
            label={LABEL.VESSEL_NAME}
            type="text"
            value={container.releaseRightContextData.vesselName}
            onChange={(e) => handleInpVesselName(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpVoyageNumber"
            label={LABEL.VOYAGE_NUMBER}
            type="text"
            value={container.releaseRightContextData.voyageNumber}
            onChange={(e) => handleInpVoyageNumber(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <>
            <InputLabel id="inpFullEmptyIndicator">{LABEL.FULLEMPTYINDICATOR}</InputLabel>
            <Select
              labelId="inpFullEmptyIndicator"
              value={
                container.releaseRightContextData.fullEmptyIndicator ??
                LABEL.FULLEMPTYINDICATOR_UNKNOWN
              }
              onChange={(e) => handleInpFullEmptyIndicator(e)}
              fullWidth
            >
              <MenuItem value={LABEL.FULLEMPTYINDICATOR_FULL}>
                {LABEL.FULLEMPTYINDICATOR_FULL}
              </MenuItem>
              <MenuItem value={LABEL.FULLEMPTYINDICATOR_EMPTY}>
                {LABEL.FULLEMPTYINDICATOR_EMPTY}
              </MenuItem>
              <MenuItem value={LABEL.FULLEMPTYINDICATOR_UNKNOWN}>
                {LABEL.FULLEMPTYINDICATOR_UNKNOWN}
              </MenuItem>
            </Select>
          </>
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpImoNumber"
            label={LABEL.IMO_NUMBER}
            type="text"
            value={container.releaseRightContextData.imoNumber}
            onChange={(e) => handleInpImoNumber(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <TextField
            id="inpStayNumber"
            label={LABEL.STAY_NUMBER}
            type="text"
            value={container.stayNumber}
            onChange={(e) => handleInpStayNumber(e)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6, md: 4 }}>
          <FormGroup style={{ margin: 'auto', position: 'relative' }}>
            <FormControlLabel
              style={{ position: 'absolute', top: '20px', right: '100px' }}
              control={
                <Checkbox
                  color="primary"
                  onChange={(e) => handleInpIsCarrierHaulage(e)}
                  checked={
                    !!isCarrierHaulage ||
                    (isCarrierHaulage && isCarrierHaulage.toLowerCase() === 'true')
                  }
                />
              }
              label={LABEL.CARRIER_HAULAGE}
            />
          </FormGroup>
        </Grid>
        <Grid size={12}>
          <Button color="primary" variant="contained" onClick={(e) => checkDatesAndHandleSubmit(e)}>
            {LABEL.UPDATE}
          </Button>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default UpdateContainerRelease;
